// extracted by mini-css-extract-plugin
export default {"main_header_container_dropdown":"nS","sticky_header_title":"oS","stycky_header_title_mob":"pS","root_scroller":"qS","scroller":"rS","indicator":"sS","scrollButtons":"tS","selected":"uS","root_tab_scrollable":"vS","root_scroller_mob":"wS","scroller_mob":"xS","indicator_mob":"yS","selected_mob":"zS","root_tab_mob":"AS","root_tab_mob_scrollable":"BS","sticky_header_title_mob":"CS"};
    if(module.hot) {
      // 1738836197545
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  